import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const InstaVideo = () => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchVideos = async () => {
        try {
            const res = await fetch("https://api.welbeing.in/home/get-videos/");
            const data = await res.json();

            if (data.status === "success") {
                setVideos(data.data);
            } else {
                throw new Error("Failed to fetch videos");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVideos();
    }, []);

    const getYoutubeEmbedUrl = (link) => {
        try {
            const url = new URL(link);
            let videoId = url.searchParams.get("v");
            if (!videoId) videoId = url.pathname.split("/").pop();
            return `https://www.youtube.com/embed/${videoId}`;
        } catch {
            return null;
        }
    };

    if (loading) {
        return (
            <section className="pb-0 ratio_asos mt-3">
                <div className="container-lg">
                    <div className="text-center py-5">
                        <span className="spinner-border" style={{ color: "#911077" }} role="status"></span>
                    </div>
                </div>
            </section>
        );
    }

    if (error || videos.length === 0) return null;

    return (
        <section className="pb-0 ratio_asos mb-5">
            <div className="container-lg">
                <div className="title-box">
                    <h2 className="unique-heading">OUR VIDEOS</h2>
                    <span className="title-divider1">
                        <span className="squre"></span>
                        <span className="squre"></span>
                    </span>
                    <p>Watch our latest collection videos and highlights.</p>
                </div>

                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={20}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    allowTouchMove={false}
                    breakpoints={{
                        576: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                    }}
                    className="video-swiper"
                >
                    {videos.map((video, index) => (
                        <SwiperSlide key={video.id}>
                            <div
                                style={{
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    border: "1px solid #f0f0f0",
                                    background: "#fff",
                                    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                                }}
                            >
                                <div style={{ position: "relative" }}>
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            left: "10px",
                                            zIndex: 2,
                                            background: video.video_type === "youtube" ? "#dc3545" : "#0d6efd",
                                            color: "#fff",
                                            fontSize: "11px",
                                            fontWeight: "600",
                                            padding: "3px 10px",
                                            borderRadius: "20px",
                                            letterSpacing: "0.3px",
                                        }}
                                    >
                                        {video.video_type === "youtube" ? (
                                            <><i className="ti ti-brand-youtube me-1"></i>YouTube</>
                                        ) : (
                                            <><i className="ti ti-video me-1"></i>Video</>
                                        )}
                                    </span>

                                    {video.video_type === "youtube" ? (
                                        <iframe
                                            src={getYoutubeEmbedUrl(video.video_link)}
                                            width="100%"
                                            height="220px"
                                            style={{ display: "block", border: "none" }}
                                            allowFullScreen
                                            title={`video-${index + 1}`}
                                        />
                                    ) : (
                                        <video
                                            src={`https://api.welbeing.in/uploads/videos/${video.video_file}`}
                                            controls
                                            style={{
                                                width: "100%",
                                                height: "220px",
                                                display: "block",
                                                objectFit: "cover",
                                                background: "#000",
                                            }}
                                        />
                                    )}
                                </div>

                                <div
                                    style={{
                                        padding: "10px 14px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        borderTop: "1px solid #f5f5f5",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            borderRadius: "50%",
                                            background: "#911077",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <i className="ti ti-player-play" style={{ color: "#fff", fontSize: "13px" }}></i>
                                    </div>
                                    <span style={{ fontSize: "13px", color: "#555", fontWeight: "500" }}>
                                        Video {String(index + 1).padStart(2, "0")}
                                    </span>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default InstaVideo;